import React from "react";
import { FiCheckCircle, FiInfo, FiXCircle } from "react-icons/fi";
import { HStack } from "@/components/composition/stack.layout";

export type AppStatus =
  | "UNDEFINED"
  | "APPLIED"
  | "INFO_PENDING"
  | "DEADLINE_PASSED"
  | "MISSING_INFO_REQUESTED";

export const APP_STATUS: Record<AppStatus, () => React.ReactNode> = {
  UNDEFINED: () => null,
  APPLIED: (): React.ReactNode => {
    return (
      <HStack className="items-center gap-x-1 rounded-md bg-[rgba(226,250,231,0.4)] px-3 py-1 text-sm text-[rgba(40,159,102,1)]">
        <FiCheckCircle />
        <span>Applied</span>
      </HStack>
    );
  },
  INFO_PENDING: (): React.ReactNode => {
    return (
      <HStack className="bg-off-orange text-info-orange w-full items-center gap-x-1 rounded-md px-3 py-1 text-sm">
        <FiInfo className="h-[14px] w-[14px]" />
        <span>Unfinished Application</span>
      </HStack>
    );
  },
  DEADLINE_PASSED: (): React.ReactNode => {
    return (
      <HStack className="bg-tint-red text-ui-red w-full items-center gap-x-1 rounded-md px-3 py-1 text-sm">
        <FiXCircle className="h-[14px] w-[14px]" />
        <span>Job Closed</span>
      </HStack>
    );
  },
  MISSING_INFO_REQUESTED: () => null,
} as const;
